import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/hire_react/collaborate_react.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud blockchain_future"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={8} lg={7} xl={6} xxl={6}>
            <h2>
              Collaborate with Professionals to{" "}
              <span>Hire Experts ReactJS Developers</span>
            </h2>
            <p>
              Having enough experience in the digital industry providing
              versatile web and app solutions, you can rely on our credibility
              to hire the finest ReactJS developers.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let Connect
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
